import React from 'react';

const ConfirmationWidget = (props) => {
    return (
        <div className="basket-wrapper">
            <h3 className="white-text busabout-h3">Thanks for booking</h3>
            <div className="basket-widget rounded-corners">
                Your reservation #{props.tmsBookingId} is now <span className="bold green-text">confirmed</span>
            </div>
        </div>
    )
}

export default React.memo(ConfirmationWidget);

